module.exports = __webpack_public_path__ + "img/justdance_01.6d62e882.jpg";